class FilterByIndustry {
  static filter(value, scope) {
    const currentFilterValue = scope.$ctrl.industryFilterValue;
    if (value && currentFilterValue !== false) {
      const filtered = value.filter(val => val.industries.includes(scope.$ctrl.selectedIndustry));
      return filtered;
    }
    return value;
  }
}

export default FilterByIndustry.filter;




// WEBPACK FOOTER //
// ./src/filters/industry.filter.js